import { render, staticRenderFns } from "./OneOrThreeWeekAddV3.vue?vue&type=template&id=53873b9b&"
import script from "./OneOrThreeWeekAddV3.vue?vue&type=script&lang=ts&"
export * from "./OneOrThreeWeekAddV3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports